module.exports = __webpack_public_path__ + "img/zhu3.82d0ce96.png";